"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _NavItem = require("./NavItem.style");

var NavItem = function NavItem(_ref) {
  var description = _ref.description,
      enhanced = _ref.enhanced,
      label = _ref.label,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["description", "enhanced", "label", "onClick"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      colors = _ref2.colors,
      space = _ref2.space;

  var animationStates = {
    rest: {
      opacity: 0
    },
    hover: {
      opacity: 1
    }
  };
  var textAnimationStates = {
    rest: {
      color: colors.greydark
    },
    hover: {
      color: colors.primary
    }
  };
  return /*#__PURE__*/_react.default.createElement(_NavItem.Wrapper, Object.assign({
    onClick: onClick
  }, rest, {
    initial: "rest",
    whileHover: "hover",
    animate: "rest"
  }), /*#__PURE__*/_react.default.createElement(_NavItem.Header, null, label && /*#__PURE__*/_react.default.createElement(_NavItem.Label, {
    enhanced: enhanced
  }, label), /*#__PURE__*/_react.default.createElement(_NavItem.IconWrapper, {
    variants: animationStates
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "ChevronRight",
    size: space.large
  })), !description && /*#__PURE__*/_react.default.createElement(_NavItem.Indicator, {
    variants: animationStates
  })), description && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavItem.Description, {
    variants: textAnimationStates
  }, description), /*#__PURE__*/_react.default.createElement(_NavItem.Indicator, {
    variants: animationStates
  })));
};

NavItem.propTypes = {
  description: _propTypes.default.string,
  enhanced: _propTypes.default.bool,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func
};
NavItem.defaultProps = {
  description: '',
  enhanced: false,
  label: '',
  onClick: function onClick() {}
};
var _default = NavItem;
exports.default = _default;